import MaskUtil from "common/util/MaskUtil";

export default function() {
	window.ObserverUtil.observeRemove('oc', () => {
		$('body').removeClass('oc-modal-visible');
	});
	window.ObserverUtil.observe('oc', () => {
		/*$('.oc-light-form__result').on('click', '.oc-light-form__close-button', function(){
			$('body').removeClass('oc-modal-open');
			$(this).closest('.oc').remove();
		});
		$('.oc-light-form__result').prepend('<span class="oc-light-form__close-button"></span>');*/


		$('.oc-light-form-field__label').each(function(){
			const label = $(this);
			const isPhone = label.closest('.oc-light-form__field').find('[name="oc[tel]"]').length > 0;

			if (!isPhone) {
				label.after(`<div class="oc-light-form-field__placeholder">${label.html()}</div>`);
			}
		});



		$('.oc-light-form-field__input').on('focus', function(){
			$(this).closest('.oc-light-form-field').addClass('oc-light-form-field_focused');
		}).on('blur', function(){
			$(this).closest('.oc-light-form-field').removeClass('oc-light-form-field_focused');
		});

		$('.oc-light-form-field__input').each(function(){
			if ($(this).val()) {
				$(this).closest('.oc-light-form-field').addClass('oc-light-form-field_hasvalue');
			}
		});

		$('.oc-light-form-field__input').on('input', function(){
			const input = $(this);
			const wrapper = input.closest('.oc-light-form-field');
			wrapper.removeClass('oc-light-form-field_error');
			if (input.val()) {
				wrapper.addClass('oc-light-form-field_hasvalue');
			} else {
				wrapper.removeClass('oc-light-form-field_hasvalue');
			}
		});

		$('.oc-light-form-field__input[type=tel]').on('focus', function(){
			$(this).closest('.oc-light-form-field').addClass('oc-light-form-field_hasvalue');
		}).on('blur', function(){
			const phoneInput = $(this);
			if (!phoneInput.val()) {
				phoneInput.closest('.oc-light-form-field').removeClass('oc-light-form-field_hasvalue');
			}
		});

		$('.oc-light-form-field__input[type=tel]').on('keyup', function(){
			$(this).closest('.oc-light-form-field').removeClass('oc-light-form-field_error');
		});

		setTimeout(() => {
			$('body').addClass('oc-modal-visible');
		}, 0);

		MaskUtil.initIntlTelMask($('.oc [name="oc[tel]"]'));
	})
}
